import React from 'react'

import { Date } from "../../components"

// Renders both generations of shipment rows: legacy AfterShip ones
// (provider relation + aftership_status + details_json checkpoints) and the
// new carrier rows (carrier_name + status lifecycle, details_json only after
// a tracking refresh). Everything is null-guarded — carrier rows have no
// provider relation and may have no details yet.
const safeParse = (json) => {
    try {
        return json ? JSON.parse(json) : null
    } catch (e) {
        return null
    }
}

const Shipment = ({ shipment }) => {
    const details = safeParse(shipment.details_json)
    const courierName = shipment.provider?.name || shipment.carrier_name || "the courier"

    const preparedMessage = `The package has been prepared and is about to be handed over to ${courierName}.`

    const AFTERSHIP_STATUSES = {
        'Info Received':        { message: preparedMessage },
        'In Transit':           { message: "The package is en route.", showLocation: true },
        'Out for Delivery':     { message: "The package is out for delivery", showLocation: true },
        'Failed Attempt':       { message: "The carrier attempted to deliver the package, but failed.", showLocation: true },
        'Delivered':            { message: "The package has been delivered. We hope you enjoy your order."},
        'Available for Pickup': { message: preparedMessage },
        'Exception':            { message: "Unknown." },
        'Expired':              { message: "" },
        'Pending':              { message: preparedMessage }
    }

    // Carrier rows carry a lifecycle status instead of an AfterShip one.
    const CARRIER_STATUSES = {
        created: { message: preparedMessage },
        manual:  { message: preparedMessage },
    }

    const status = shipment.aftership_status
        ? AFTERSHIP_STATUSES[shipment.aftership_status]
        : (shipment.delivered_at
            ? AFTERSHIP_STATUSES['Delivered']
            : CARRIER_STATUSES[shipment.status])

    return (
        <div className="shipment">
            <h3>Shipment information</h3>

            <div className="card">
                <p>{ status?.message }</p>

                { shipment.tracking_number && (
                    <p className="mt-3">Your tracking number is { shipment.tracking_link
                        ? <a className="tracking-link" href={shipment.tracking_link} target="_blank" rel="noreferrer">{shipment.tracking_number}</a>
                        : <span className="tracking-link">{shipment.tracking_number}</span> }.</p>
                )}

                { status?.showLocation && details?.checkpoints?.length > 0 && (
                    <div className="locations mt-3">
                        <h4 className="mb-3">Location history</h4>

                        { details?.checkpoints?.map((c,i) =>
                            <div key={i}>
                                <Date type="ago" date={c.checkpoint_time} />
                                <span>{c.location || (c.city + " " + c.state)}</span>
                            </div>
                        )}
                    </div>
                )}

                { (details?.updated_at || shipment.status_updated_at) && (
                    <p className="meta mt-3">Updated: <Date type="ago" date={details?.updated_at || shipment.status_updated_at} /></p>
                )}
            </div>
        </div>
    )
}

export default Shipment
